/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-north-1",
    "aws_mobile_analytics_app_id": "3571b2f26aea4be0812a2949ce6d7b25",
    "aws_mobile_analytics_app_region": "eu-central-1",
    "aws_cognito_identity_pool_id": "eu-north-1:71fe827a-ae4d-425d-b255-189b8f27c002",
    "aws_cognito_region": "eu-north-1",
    "aws_user_pools_id": "eu-north-1_F1nvKd3so",
    "aws_user_pools_web_client_id": "2u8j7u50ghgshmu3i4hjmd6i8m",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
